import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { GlobalVariables } from 'app/services/globals';
import { UpdateMethod } from 'shell-models-lib';
import { getAppendOption } from 'app/registries/consts/copy-job-const';

export const eventStreamDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.eventStream.datasetType,
    displayName: stringResources.EventStream_DisplayText,
    tableNameDisplay: stringResources.EventStream_StreamName,
    tableNamePlural: stringResources.TransformationInspect_Streams,
    supportLinkedServiceTypes: [adfModelTypeMap.eventStream.linkedServiceType],
    isSource: GlobalVariables.eventStreamSourceInCopyJob,
    isSink: GlobalVariables.eventStreamSinkInCopyJob,
    datasetKind: 'table',
    icon: {
        className: 'svg-eventstream_32_regular'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    supportDataFlowSource: false,
    supportDataFlowSink: false,
    notSupportAdditionalColumns: true,
    notSupportLookupActivity: true,
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getAppendOption()],
            defaultUpdateMethod: UpdateMethod.Append,
            updateMethodProperties: ['writeBehavior']
        }
    }
};
